import {MedicalRecord, MedicalRecordDto} from "../types/medicalRecord";
import {DateTime} from "luxon";

export const mapMedicalRecordDtoToMedicalRecord = (dto: MedicalRecordDto): MedicalRecord => ({
    id: dto.id,
    appointmentId: dto.appointmentId,
    version: dto.version,
    medicalInterview: dto.medicalInterview,
    drugMedicalRecommendations: dto.drugMedicalRecommendations,
    otherMedicalRecommendation: dto.otherMedicalRecommendation,
    icD10TextPl: dto.icD10TextPl,
    icD10TextEn: dto.icD10TextEn,
    icD10Code: dto.icD10Code,
    creationDateTime: DateTime.fromISO(dto.creationDateTime),
})
